export default __webpack_public_path__ + "static/media/ic-qr-code.d2699921.svg";